<div class="airport-panel-container" (click)="onClick()">
  <div class="airport-panel-icon">
    <app-icon [icon]="Icons.airplane" [invert]="invert"/>
  </div>
  <h6 class="airport-panel-text">
    <app-texts
      [texts]="[
                {text: ['Уникальные места', 'Unexpected Discovers']}
              ]"
    />
  </h6>
</div>

